import React from 'react';

const Cart = () => <div>Cart</div>;

export default Cart;
